import { render, staticRenderFns } from "./ResizeSocialGroup.vue?vue&type=template&id=05246c01&scoped=true&"
import script from "./ResizeSocialGroup.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ResizeSocialGroup.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ResizeSocialGroup.vue?vue&type=style&index=0&id=05246c01&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05246c01",
  null
  
)

export default component.exports